module.exports = __webpack_public_path__ + "img/cp-order-list.svg";